<template>
  <div class="ActivityDiscount">
    <img :src="imgUrl" alt="大方租车 押金双免"/>
    <div class="getActivityDiscount" @click="getActivityDiscount"></div>
  </div>
</template>

<script>
import { orderSource } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: 'laborDay',
  data(){
    return {
      imgUrl: 'https://cms.dafang24.com/aliapp/20191012/laborDay.jpg',
      couponList: [
        {
          name: "五一租5天立减180元",
          OfferID: 259
        },
        {
          name: "五一租3天立减100元",
          OfferID: 258
        }
      ]
    }
  },
  created () {},
  mounted () {},
  methods: {
    getActivityDiscount(){
      if( localStorage.getItem('token') ){
        this.consumerCouponsFn();
      } else {
        this.flexible.showToast({content:'请先登陆/注册！'})
      }
    },
    goHome () {
      if( orderSource==17 ){
        window.webkit.messageHandlers.goHome.postMessage(null);
      } else if ( orderSource==16 ){
        dfpanda.goHome();
      }
    },
    async consumerCouponsFn () { // 获取用户优惠券
      let res = await getConsumerCoupons();
      if( res.Code==100 ){
        let uCoupon = res.Data || [];
        if( uCoupon.length ){
          for( let i in uCoupon ){
            for( let j in this.couponList ){
              if( uCoupon[i].OfferID == this.couponList[j].OfferID ){
                this.couponList.splice(j, 1)
              }
            }
          }
        }
        // console.log(this.couponList);
        if( this.couponList.length ){
          let lastRes = false;
          for( let item of this.couponList ){
            let gRes = await this.getDrawCoupon(item.OfferID);
            if( gRes ){ lastRes = gRes }
          }
          if( lastRes ){
            this.flexible.showToast({
              duration:1200,
              content:'领取成功！去租车',
              success:()=>{
                this.goHome()
              }
            });
          } else {
            this.flexible.showToast({content:'领取失败，请重试'})
          }
        } else {
          this.flexible.showToast({
            duration:1200,
            content:'领取成功！去租车',
            success:()=>{
              this.goHome()
            }
          })
        }
      }
    },
    async getDrawCoupon ( offerID ) {
      let res = await DrawCoupon({
        data: {
          OfferID: offerID,
          orgID: 0
        },
        isLoading: 1,
        loadContent: '获取优惠券...'
      });
      if( res.Code==100 ){
        return true;
      }
      return false;
    }
  }
}
</script>
<style lang="scss" scoped>
  .ActivityDiscount {
    position: relative;
    img {
      width: 100%;
    }
    .getActivityDiscount {
      position: absolute;
      left: 0; top: 0;
      width: 100%;
      height: 100%;
      /*background-color: rgba(0,0,0, .5);*/
    }
  }
</style>